// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main{background-color:#fff;height:calc(100vh - 70px);padding:30px;box-sizing:border-box}.box{text-align:center;width:500px;margin:5vh auto 0;color:#666}.box a{color:#1241a8}", ""]);
// Exports
module.exports = exports;
